export const engagementAudienceSyncPlatformAdAccounts = "/engagement/audience_sync/:platform/ad_accounts";
